const WagerTypesConst = [
  { name: "Win", poolType: 0 },
  { name: "Place", poolType: 1 },
  { name: "Show", poolType: 2 },
  { poolType: 3, name: "DailyDouble" },
  { poolType: 4, name: "Exacta" },
  { poolType: 5, name: "Trifecta" },
  { poolType: 6, name: "Quinella" },
  { poolType: 7, name: "Superfecta" },
  { poolType: 8, name: "Pick3" },
  { poolType: 9, name: "Pick4" },
  { poolType: 10, name: "Pick6" },
  { poolType: 11, name: "Pick5" },
  { poolType: 12, name: "Pick7" },
  { poolType: 13, name: "Pick8" },
  { poolType: 14, name: "Pick9" },
  { poolType: 15, name: "Pick10" },
  { poolType: 16, name: "Pick11" },
  { poolType: 17, name: "Pick12" },
  { poolType: 18, name: "High5" },
  { poolType: 19, name: "Omni" },
  { poolType: 20, name: "GrandSlam" },
];

export default WagerTypesConst;
